const popupCloseButtons = document.querySelectorAll('.-live .popup__close');

[...popupCloseButtons].forEach(closeBtn => {
    const wrapper = closeBtn.closest('.popup-wrapper');
    if (wrapper) {
        closeBtn.addEventListener('click', () => {
            closePopup(wrapper);
        });
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape' || e.key === 'Enter') {
                closePopup(wrapper);
            }
        });
    }
});

function closePopup(wrapperElement) {
    wrapperElement.classList.add('closed');
    setTimeout(function() {
        wrapperElement.style.display = 'none';
    }, 500);
}
